<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Gender" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-gender-form [gender]="gender" *ngIf="gender"></app-gender-form>
        </form>
      </div>
    </section>
  </div>
</div>
